import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { CheckIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-223">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-green/30 to-transparent" data-id="element-224" />

      <div className="relative z-10 max-w-3xl mx-auto px-4" data-id="element-225">
        <SectionReveal data-id="element-226">
          <p className="text-4xl mb-4 text-center" data-id="element-227">🧩</p>
          <p className="text-lg sm:text-xl text-gray-400 font-body text-center mb-4 italic" data-id="element-228">
            Esto no es teoría ni consejos genéricos de internet
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase tracking-[-0.02em]" data-id="element-229">
            Es un sistema paso a paso aplicado en facturas reales en Argentina
          </h2>
          <p className="text-xl sm:text-2xl text-gray-300 font-body text-center mb-10" data-id="element-230">
            Una forma simple y directa de:
          </p>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-231">
          <div className="space-y-5 mb-12 max-w-xl mx-auto" data-id="element-232">
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-233">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-234">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-235" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-236">
                Detectás consumos ocultos
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-237">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-238">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-239" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-240">
                Corregís errores que aumentan el gasto
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-241">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-242">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-243" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-244">
                Aplicás cambios simples desde tu casa
              </p>
            </div>
            <div className="flex items-center gap-4 bg-brand-green/10 border border-brand-green/20 rounded-lg p-5" data-id="element-245">
              <div className="w-8 h-8 bg-brand-green rounded-full flex items-center justify-center flex-shrink-0" data-id="element-246">
                <CheckIcon className="w-5 h-5 text-white" aria-hidden="true" data-id="element-247" />
              </div>
              <p className="text-gray-100 font-body text-lg font-semibold m-0" data-id="element-248">
                Reducís el monto de tu próxima factura
              </p>
            </div>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.2} data-id="element-249">
          <div className="text-center mb-12" data-id="element-250">
            <p className="text-xl sm:text-2xl text-gray-400 font-body mb-2" data-id="element-251">
              Sin tecnicismos. Sin vueltas.
            </p>
            <p className="text-xl sm:text-2xl text-blue-400 font-body font-bold" data-id="element-252">
              👉 Solo lo que funciona.
            </p>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.3} data-id="element-253">
          <div className="text-center" data-id="element-254">
            <CTAButton text="QUIERO LA GUÍA" scrollTo="oferta" size="lg" data-id="element-255" />
          </div>
        </SectionReveal>
      </div>
    </section>;
}